<script setup>
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { Button } from '@/components/ui/button'

// This is how you allow a component to refer to itself in <script setup>
defineOptions({
  name: 'RecursiveNav'
})

// Get the navigation items array
defineProps({
  items: {
    type: Array,
    default: () => []
  }
})
</script>

<template>
  <div class="space-y-1">
    <template v-for="item in items" :key="item.title">
      <RouterLink v-if="!item.children || item.children.length === 0" v-slot="{ navigate, isExactActive }" :to="item.to" custom>
        <Button :variant="isExactActive ? 'secondary' : 'ghost'" class="w-full justify-start" @click="navigate">
          {{ $t(item.title) }}
        </Button>
      </RouterLink>
      <Accordion v-else type="single" collapsible :default-value="item.expanded ? item.id : undefined">
        <AccordionItem :value="item.id" class="border-b-0">
          <AccordionTrigger class="hover:no-underline">
            {{ $t(item.title) }}
          </AccordionTrigger>
          <AccordionContent>
            <div class="ml-0">
              <RecursiveNav :items="item.children" />
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </template>
  </div>
</template>
